import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 48,
  height = 48,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || "0 0 48 48"}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
  >
    <path
      d="M26.0975 30.7691V18.769C26.0975 16.8282 28.4638 16.3632 29.03 18.1926L32.7943 29.8074C33.3604 31.6368 35.7267 31.1718 35.7267 29.231V17.0403M17.6353 25.6208H13.2306M12.3686 30.8644V19.9004C12.3686 18.3208 13.6491 17.0403 15.2288 17.0403H20.4001M46.5 11.0339V36.9661C46.5 42.2315 42.2315 46.5 36.9661 46.5H11.0319C5.76756 46.5 1.5 42.2324 1.5 36.9681V11.0339C1.5 5.76852 5.76852 1.5 11.0339 1.5H36.9661C42.2315 1.5 46.5 5.76852 46.5 11.0339Z"
      stroke={fill}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVG;
